import { Helmet } from 'react-helmet-async'

export default function HubSpot() {
	return (
		<Helmet>
			<script type="text/javascript" id="hs-script-loader" async defer src="//js-na1.hs-scripts.com/23310038.js" />
		</Helmet>
	)
}
